import ActionTypes from "./ActionTypes";

export const queueChangesAction = (payload) => ({
    type: ActionTypes.QUEUE_CHANGES,
    payload,
});
